import React from "react";
import { Link } from "react-router-dom";


import VerticalList from "../../verticals/VerticalList";


const VerticalListDisplay = () => {



    return (
        <div className="vertical_list_display">
            <ul className="list-unstyled">
                    <li><b className="text-dark-orange">Industries</b></li>
                { VerticalList.map((item,index)=>(
                    <li key={index}>
                        <Link to={item.link} >{item.title}</Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default VerticalListDisplay;